import { codeInputCommonAttrs } from '../../../common/$models'
import { ColumnTypes, ModelDef } from '../../../common/$models/ModelDef'

const serverSideAppHooksConfigTypes = {
  rawFunction: {
    label: 'Hook, 関数を直接指定',
    useFields: ['appHookName', 'function', 'hookType'],
  },
}

export const serverSideAppHooks: ModelDef = {
  tableName: 'serverSideAppHooks',
  tableLabel: 'サーバサイドカスタムHooks',
  primaryKeyColType: 'UUID',
  defaultSort: { key: 'updatedAt', order: 'desc' },
  modelType: 'admin',
  columns: {
    title: {
      label: '管理用名称',
      type: ColumnTypes.String,
      validate: { notEmpty: true },
      width: {
        xs: 48,
      },
      listItemAttrs: {
        class: { 'no-ellipsis': true, 'whitespace-wrap': true },
        style: { minWidth: '320px', maxWidthSS: '320px' },
      },
    },
    description: {
      label: '説明',
      type: ColumnTypes.Text,
      width: { xs: 48 },
      listItemAttrs: {
        class: { 'no-ellipsis': true, 'whitespace-wrap': true },
        style: { minWidth: '320px', maxWidthSS: '320px' },
      },
    },
    configType: {
      label: '設定タイプ',
      type: ColumnTypes.String,
      selections: () => {
        return Object.keys(serverSideAppHooksConfigTypes)
      },
      customLabel: value => serverSideAppHooksConfigTypes[value]?.label,
      defaultValue: 'rawFunction',
    },
    functionName: {
      label: '$appHook 登録関数名',
      type: ColumnTypes.String,
      validate: { notEmpty: true },
      listItemAttrs: {
        class: { 'no-ellipsis': true, 'whitespace-wrap': true },
        style: { minWidth: '320px', maxWidth: '320px' },
      },
    },
    appHookName: {
      label: '$appHook Hook名',
      type: ColumnTypes.String,
      validate: { notEmpty: true },
      editable: row => row.configType === 'rawFunction',
      inputHelpText:
        '初期化時に実行するには <code>$coreApi.initialized</code> を 設定します。',
      width: {
        xs: 'grow-1'
      },
      // enableIf: (row) => row.configType === 'rawFunction',
    },
    function: {
      type: ColumnTypes.Text,
      label: '実行関数',
      validate: { notEmpty: true },
      enableIf: row => row.configType === 'rawFunction',
      inputAttrs: {
        ...codeInputCommonAttrs,
        initCode: `/**
* @param args {Record<string, any>}
* @param executionContext {Record<string, any>}
* @param coreServices {CoreServersideServices}
*/
return async (args, executionContext, coreServices) => {
  // 処理を記載
  // 例: SQL 発行
  // const res = await coreServices.executeRawSQL('SELECT * FROM selectOptionsMaster')
  // 例: hook に 挙動を登録
  // coreServices.$appHook.on(
  //   'someOrderItems.afterSave',
  //   /** @param afterSaveArgs {import('server/storeMethodsExecutionOnServerSide/storeMethodServerSide').StoreMethodsAppHookArgs} */
  //   (afterSaveArgs) => {
  //     afterSaveArgs
  //   },
  //   'regiter hook for xxxxx-yyyy-zzzzz'
  // )
  return args
}
`,
      },
      inputHelpText: `args から 各種サービスを取得して利用可能です。 const productItemService = args.itemServiceGenerator('products', {adminMode: true}) { req, res, next, services, exceptions, env, database, getSchema, data, docIds, savedKeys, thisItemService, itemServiceGenerator, coreServices }`,
    },
  },
}

export type ModelServerSideAppHooks = {
  id?: string
  title?: string
  configType?: keyof typeof serverSideAppHooksConfigTypes
  functionName?: string
  appHookName?: string
  function?: string
  modelName?: string
  hookType?: string
  dataFilterOnlyCreateRecords?: boolean
  dataFilterUseFunction?: boolean
  dataFilter?: string
  dataFilterFunction?: string
}
